export default function Services() {
  const services = [
    {
      icon: 'ri-flashlight-line',
      title: 'Ingeniería Eléctrica',
      description: 'Soluciones eléctricas completas para proyectos residenciales, comerciales e industriales',
      items: [
        'Diseño de sistemas eléctricos',
        'Tableros eléctricos',
        'Redes de distribución',
        'Sistemas de puesta a tierra',
        'Estudios eléctricos'
      ],
      color: 'blue'
    },
    {
      icon: 'ri-building-line',
      title: 'Arquitectura',
      description: 'Diseño arquitectónico innovador y funcional para todo tipo de proyectos',
      items: [
        'Diseño arquitectónico',
        'Desarrollo de planos',
        'Supervisión de obra',
        'Remodelaciones'
      ],
      color: 'gray'
    },
    {
      icon: 'ri-tools-line',
      title: 'Ingeniería Integral',
      description: 'Gestión completa de proyectos desde el diseño hasta la ejecución',
      items: [
        'Diseño de proyectos',
        'Gestión técnica',
        'Supervisión y ejecución',
        'Consultoría especializada'
      ],
      color: 'blue'
    },
    {
      icon: 'ri-factory-line',
      title: 'Proyectos Industriales',
      description: 'Soluciones especializadas para el sector industrial y energético',
      items: [
        'Instalaciones eléctricas industriales',
        'Optimización energética',
        'Infraestructura técnica'
      ],
      color: 'gray'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nuestros <span className="text-blue-600">Servicios</span>
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Ofrecemos soluciones integrales de <strong>ingeniería eléctrica</strong> y <strong>arquitectura</strong> para proyectos en <strong>Lima</strong> y todo el <strong>Perú</strong>
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
            >
              <div className={`w-16 h-16 flex items-center justify-center rounded-xl ${service.color === 'blue' ? 'bg-blue-100' : 'bg-gray-100'} mb-6`}>
                <i className={`${service.icon} text-3xl ${service.color === 'blue' ? 'text-blue-600' : 'text-gray-700'}`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
              <ul className="space-y-3">
                {service.items.map((item, idx) => (
                  <li key={idx} className="flex items-start">
                    <i className="ri-check-line text-blue-600 text-xl mr-3 mt-0.5"></i>
                    <span className="text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}